'use strict';

class RALSelect {
    constructor(selectBox = "RALSelectBox", initALL = true) {
        this.selectBox = selectBox;
        console.log(`Init RAL select interactive box module`);
        if (initALL) this.initDialog();
    }

    initDialog() {
        // init interactive act
        $('#' + this.selectBox)
            .on('shown.bs.modal', (event) => this.loadControlsValues(event))
            .on('hidden.bs.modal', () => this.finalizeBox())
            .on('keypress', (event) => {
                if (event.keyCode === 10 || event.keyCode === 13) {
                    this.onConfirm(event);
                    event.preventDefault();
                }
            })
            .find("button.confirm")
            .on('click', (event) => this.onConfirm(event));

        $("#colors-tabContent label > input + span").each((index, item) => {
            $(item).addClass("bg-color-ral-" + item.innerHTML);
        });
        return this;
    }

    loadControlsValues(event) {
        this.RALbutton = event.relatedTarget;
    }

    onConfirm() {
        let prevRALColor = $(this.RALbutton).data("ral"),
            selectedRALColor = $("#" + this.selectBox).modal("hide").find(".tab-pane.active .btn-secondary.active > input + span").text();
        $(this.RALbutton).removeClass("btn color-control ral selected bg-color-ral-" + prevRALColor).addClass("btn color-control ral selected bg-color-ral-" + selectedRALColor).data("ral", selectedRALColor);
    }

    finalizeBox() {}
}

export default RALSelect;
